module.exports = __webpack_public_path__ + "assets/img/station20.1de1001f.png";